import { Pipe, type PipeTransform } from "@angular/core";
import { Nullable } from "@playcharge/common/models/backend/nullable";

@Pipe({
    name: "appFilter",
    standalone: true,
})
export class FilterPipe implements PipeTransform {
    transform<T>(value: Nullable<T[]>, filterFn: (item: T) => boolean): Nullable<T[]> {
        if (!value || !value.length) {
            return value;
        }

        return value.filter(filterFn);
    }
}
